import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {apiV2} from "api/firebase";
import {notify} from "tools/snackbar";
import expoPlatformLogo from "assets/images/show/ExpoPlatform.png";
import useStyles from "./styles";

type ExpoPlatformButton = {
  showId: string;
  exhibitorPairId: string;
};

function ExpoPlatformButton({exhibitorPairId, showId}: ExpoPlatformButton) {
  const classes = useStyles({headerBackground: false});

  const handleButtonClick = async () => {
    const {link, isSyncing} = await apiV2.expoPlatform.getSSOLink({
      showId,
      exhibitorPairId,
    });

    if (isSyncing) {
      notify(
        "Your company is still being synced to Expo Platform. Please try again in a few minutes.",
        {variant: "info"}
      );
      return;
    }

    if (!link) {
      return;
    }
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <Box className={classes.tooltipAppItem} onClick={handleButtonClick}>
      <Box className={classes.tooltipItemLink}>
        <Box className={classes.imageBox}>
          <img src={expoPlatformLogo} alt="EP" />
        </Box>
        <Typography>EP</Typography>
      </Box>
    </Box>
  );
}

export default ExpoPlatformButton;
